import React from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';

const SYSTEM = process.env.REACT_APP_COUNTRY || 'MX' ;

const Container = styled.div`
    display: ${({ show })=>( show ? 'flex' : 'none')};
    flex-direction: 'row';
    align-items: center;
    justify-content: space-between;
`;

const SVG = styled.svg`
    width: ${({ width })=>(width)};
    height: ${({ height })=>(height)};
`;

const Letter = styled.path`
    fill: ${({theme:{header}})=>(header.letter)};
    transition: fill 800ms 150ms;
`; 

const Shape = styled.path`
    fill: ${({theme:{header}})=>(header.isotype)};
    transition: fill 800ms 200ms;
`;

const BrandText = styled.h1`
    margin-left: 15px;
    font-size: 28px;
    color: ${({ theme:{ brand }})=>( brand.letter)};
    font-weight: 100;
    letter-spacing: 2px;
    padding: 2px 8px;
    background: ${({ theme:{ brand }})=>( brand.bg)};
    border-radius: var(--main-border-radius);
    text-transform: uppercase;
    transition: color 800ms 150ms, background 800ms 200ms;
    ${ SYSTEM === 'US' && `transform: skew(-7deg)`}
`;

const mainBrand = ({ width, height , subheader, show, className, onRef}) =>  (
    <Container className={className} show={show} innerRef={onRef} >
        <SVG width={width} height={height}  version='1.1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' viewBox='0 0 428 258' preserveAspectRatio='xMinYMin meet'>
            <g>
                <Shape d='M253.63,187.1c1.96-5.18,3.91-10.36,5.87-15.53c1.76-4.64,3.56-9.26,5.27-13.92c0.53-1.43,1.4-1.94,2.87-1.8
                    c17.56,1.67,35.13,3.32,52.69,4.98c0.23,0.02,0.46,0.15,1.18,0.39c-3.71,1.16-7.13,1.25-10.48,1.7
                    c-11.74,1.59-23.49,3.1-35.25,4.57c-1.47,0.18-1.94,1.01-2.36,2.19c-3.32,9.53-6.67,19.05-10,28.57
                    c-5.02,14.37-10.03,28.74-15.06,43.11c-0.24,0.68-0.27,1.51-1.57,2.04c-12.29-56.2-24.56-112.3-36.83-168.4
                    c-0.16-0.02-0.33-0.04-0.49-0.06c-0.5,2.38-1.04,4.76-1.49,7.15c-6.01,31.55-12.01,63.1-18.01,94.65
                    c-0.33,1.73-0.67,3.47-0.96,5.21c-0.26,1.61-1.09,2.3-2.78,2.13c-12.96-1.29-25.92-2.55-38.88-3.78
                    c-8.03-0.76-16.07-1.46-24.1-2.21c-1.31-0.12-2.62-0.35-3.92-1.09c4.48-0.49,8.95-1.01,13.43-1.47
                    c13.21-1.36,26.41-2.72,39.62-4.02c1.55-0.15,2.18-0.86,2.49-2.28c4.35-20.05,8.74-40.08,13.12-60.13
                    c5.09-23.33,10.17-46.65,15.25-69.98c0.95-4.35,2.01-8.68,2.84-13.06c0.36-1.9,1.3-2.53,3.09-2.49c8.99,0.19,7.08-1.39,8.84,6.51
                    c11.49,51.53,22.91,103.08,34.36,154.61c0.18,0.8,0.43,1.58,0.64,2.37C253.22,187.07,253.43,187.09,253.63,187.1z'/>
                <Letter d='M41.09,96.48c-3.63-0.17-7.66,0.25-11.68-0.51c-5.57-1.05-9.4-4.01-10.76-9.63c-1.79-7.39-1.74-14.85-0.03-22.22
                    c1.28-5.52,5.44-8.27,10.56-9.78c4.01-1.18,8.13-1.31,12.25-0.93c6.27,0.56,12.53,1.26,18.79,1.9c3.58,0.36,5.1,2.93,3.75,6.28
                    c-0.42,1.03-1.26,1.01-2.09,0.98c-6.13-0.24-12.25-0.48-18.38-0.77c-3.95-0.19-7.89-0.51-11.8,0.35c-3.34,0.74-4.9,2.36-5.45,5.77
                    c-0.74,4.59-0.77,9.2-0.1,13.8c0.62,4.31,2.62,6.19,7.06,6.33c5.38,0.17,10.76,0.05,16.14,0.16c2.01,0.04,4.04,0.19,6.01,0.58
                    c6.2,1.22,9.96,5.39,10.99,12.79c0.72,5.16,0.71,10.44,0.02,15.6c-1.01,7.5-5.53,11.23-13.94,12.57
                    c-7.68,1.23-15.24-0.15-22.84-0.78c-2.51-0.21-5.01-0.56-7.49-0.99c-2.23-0.39-2.71-1.87-2.19-5.45c0.32-2.16,1.86-1.57,3.09-1.46
                    c8.38,0.79,16.77,1,25.18,0.81c2.13-0.05,4.16-0.62,6.05-1.57c2.53-1.27,4.01-3.32,4.06-6.2c0.06-3.36,0.12-6.73-0.03-10.09
                    c-0.22-4.84-2.82-7.36-7.69-7.52C47.55,96.4,44.52,96.48,41.09,96.48z'/>
                <Letter  d='M299.9,106.49c-3.45,0-6.9,0.14-10.34-0.04c-2.46-0.13-3.18,0.89-2.84,3.1c0.34,2.15,0.52,4.35,1.04,6.46
                    c0.83,3.38,3.19,5.36,6.71,5.4c7.89,0.09,15.8,0.39,23.68-0.41c0.17-0.02,0.33-0.03,0.5-0.04c3.66-0.28,5.19,1.94,3.72,5.35
                    c-0.39,0.91-1.22,1.11-2.03,1.3c-9.16,2.16-18.48,2.67-27.81,2c-6.91-0.5-11.02-4.46-12.53-11.51
                    c-2.16-10.05-2.27-20.19-0.42-30.29c1.47-7.97,6.29-12.28,14.35-13.29c5.61-0.71,11.23-0.73,16.84-0.01
                    c7.96,1.01,12.03,5.72,12.68,14.71c0.09,1.17,0.07,2.35,0.07,3.53c0.01,9.29-4.18,13.56-13.54,13.74
                    C306.63,106.54,303.26,106.49,299.9,106.49z M299.48,98.21c0-0.01,0-0.01,0-0.02c3.61,0,7.22,0.09,10.83-0.02
                    c3.39-0.1,4.85-1.69,4.89-5.05c0.02-1.84-0.07-3.66-0.42-5.5c-0.57-2.92-2.35-4.3-5.11-4.76c-5.18-0.85-10.37-0.71-15.54,0.04
                    c-2.46,0.35-4.31,1.63-5.58,3.85c-1.61,2.83-1.49,5.97-1.86,9.03c-0.23,1.9,0.63,2.51,2.46,2.46
                    C292.6,98.15,296.04,98.21,299.48,98.21z'/>
                <Letter d='M119.82,74.45c-3.48,4.91-7.82,8.38-11.75,12.28c-3.22,3.2-6.49,6.35-9.87,9.37c-1.53,1.37-1.51,2.36-0.27,3.94
                    c7.01,8.93,13.92,17.93,20.85,26.92c0.44,0.57,1.35,1.11,0.98,1.89c-0.37,0.77-1.36,0.31-2.08,0.43c-5.12,0.84-8.72-0.9-11.83-5.31
                    c-4.93-7-10.59-13.48-15.96-20.17c-0.47-0.58-0.94-1.26-1.58-1.58c-1.84-0.94-3.12,0-3.12,2.28c-0.03,6.98-0.01,13.96-0.01,20.94
                    c0,3.83-0.01,3.85-3.7,3.83c-5.09-0.03-4.58,0.48-4.58-4.63c-0.02-24.14-0.01-48.27,0-72.41c0-3.47,0.01-3.47,3.52-3.49
                    c4.76-0.03,4.76-0.03,4.76,4.83c0,12.11-0.02,24.22,0.03,36.33c0.01,1.23-0.72,2.93,0.94,3.59c1.67,0.66,3.06-0.28,4.29-1.43
                    c5.59-5.22,11.24-10.38,16.76-15.67c1.45-1.39,2.9-2.09,4.91-1.99C114.68,74.54,117.25,74.45,119.82,74.45z'/>
                <Letter d='M144.37,157.01c-5.34,0-4.82,0.28-3.19-4.54c2.35-6.93,4.81-13.81,7.25-20.7c0.51-1.45,0.73-2.27-1.38-2.69
                    c-5.3-1.07-7.94-5.08-9.47-9.85c-2.91-9.04-5.68-18.12-8.49-27.2c-1.54-4.98-3-9.98-4.6-14.94c-0.67-2.06-0.06-2.73,2.04-2.66
                    c7.14,0.22,5.81-1.17,7.97,5.81c3.79,12.2,7.59,24.39,11.39,36.59c0.41,1.3,0.95,2.5,2.13,3.33c2.21,1.54,3.93,1.03,4.79-1.52
                    c4.62-13.7,9.27-27.39,13.78-41.13c0.75-2.3,1.82-3.19,4.28-3.11c6.72,0.21,6.22-0.59,4.12,5.67
                    c-8.12,24.23-16.24,48.45-24.47,72.64C148.88,157.5,149.87,156.98,144.37,157.01z'/>
                <Letter d='M387.85,100.14c0-5.56-0.08-10.19,0.04-14.82c0.05-2.02-0.71-2.7-2.65-2.58c-1.84,0.11-3.7,0.01-5.55,0
                    c-1.2-0.01-1.91-0.54-1.9-1.82c0-0.17-0.02-0.34-0.02-0.5c0.01-7.03-0.56-5.85,5.59-5.96c0.42-0.01,0.85-0.06,1.26,0.01
                    c2.49,0.45,3.47-0.71,3.67-3.1c0.26-3.26,0.82-6.5,1.08-9.77c0.26-3.21,2.63-2.07,4.35-2.27c1.9-0.22,2.5,0.79,2.47,2.56
                    c-0.06,3.36,0.06,6.73-0.04,10.09c-0.05,1.84,0.59,2.56,2.48,2.51c3.61-0.1,7.23,0.02,10.85-0.04c1.71-0.03,2.42,0.63,2.4,2.37
                    c-0.06,6.83,0.57,5.89-5.65,5.96c-2.69,0.03-5.38,0.04-8.07,0c-1.37-0.02-1.99,0.56-1.98,1.95c0.04,9.59-0.08,19.18,0.13,28.76
                    c0.1,4.76,2,6.68,6.65,7.91c1.71,0.45,3.42,0.85,5.13,1.28c2.53,0.64,3.78,3.42,2.63,5.74c-0.38,0.76-1.04,0.8-1.7,0.8
                    c-3.2,0.01-6.41,0.2-9.58-0.07c-5.85-0.49-9.93-5.24-11.06-12.31C387.43,110.97,388.1,105.08,387.85,100.14z'/>
                <Letter  d='M258.38,82.38c0,9.25,0,18.51,0,27.76c0,1.18-0.02,2.36,0.09,3.53c0.47,4.81,1.83,6.44,6.52,7.75
                    c2.1,0.59,4.24,1.05,6.36,1.59c2.77,0.7,1.53,2.95,1.68,4.6c0.16,1.79-1.25,1.66-2.43,1.67c-1.85,0.02-3.7,0.01-5.55,0.01
                    c-8.5,0-12.93-3.68-14.39-12.01c-0.39-2.23-0.62-4.49-0.61-6.77c0.03-19.35,0.01-38.7,0.02-58.04c0-3.69,0.01-3.69,3.6-3.71
                    c4.72-0.02,4.72-0.02,4.72,4.6C258.38,63.03,258.38,72.7,258.38,82.38z'/>
                <Letter d='M334.35,101.84c0-8.16-0.01-16.32,0.02-24.47c0-1.18-0.37-2.85,1.56-2.83c1.83,0.02,4.05-1.03,5.05,1.85
                    c1.56,4.49,1.71,4.52,5.85,2.11c6.08-3.53,12.58-5.03,19.58-4.55c3.71,0.25,4.06,0.56,4.07,4.38c0.01,4.21,0,4.29-4.07,3.99
                    c-7.96-0.59-15.32,1.3-22.32,5.03c-1.47,0.78-1.41,1.91-1.41,3.16c0,11.69,0.02,23.38-0.03,35.07c0,1.24,0.66,3.14-1.03,3.5
                    c-2.17,0.47-4.55,0.65-6.7-0.19c-0.9-0.35-0.55-1.67-0.56-2.57C334.35,118.15,334.35,109.99,334.35,101.84z'/>
            </g>
        </SVG>
        {
            subheader && ( <BrandText>NEWS</BrandText> )
        }
    </Container>
);

/* PropTypes */
mainBrand.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    show: PropTypes.bool,
    onRef: PropTypes.object,
};

/* Default */
mainBrand.defaultProps = {
    show: true,
    className: '',
};

export default withTheme(mainBrand);


// WEBPACK FOOTER //
// ./src/components/Brand/index.js